import ConfigGuestModalView from "../../app/angularjs/events/guests/configGuestModal.html";
import SearchGuestsModalView from "../../app/angularjs/events/guests/searchGuestsModal.html";
import SearchGroupModalView from "../../app/angularjs/events/guests/searchGroupModal.html";
import AssignParkingsModalView from "../../app/angularjs/events/guests/assignParkings.html";
import AssignAccreditationModalView from "../../app/angularjs/events/guests/assignAccreditation.html";
import AssignActsModalView from "../../app/angularjs/events/guests/assignActs.html";
import AssignAnnexesModalView from "../../app/angularjs/events/guests/assignAnnexes.html";
import AssignTagsModalView from "../../app/angularjs/tags/AssignTagsModal.html";
import AddNewPersonModalView from "../../app/angularjs/events/guests/addNewPersonModal.html";
import AddNewParkingModalView from "../../app/angularjs/events/parkings/addNewParkingModal.html";
import AssignZoneModalView from "../../app/angularjs/events/guests/assignZone.html";
import GuestNotesModalView from "../../app/angularjs/events/guests/guestNotesModal.html";
import GuestSpaceZonesModalView from "../../app/angularjs/events/guests/guestSpaceZonesModal.html";
import GuestVehiclesModalView from "../../app/angularjs/events/guests/guestVehiclesModal.html";
import AssignCompanionsLimitModalView from "../../app/angularjs/events/guests/assignCompanionsLimit.html";
import AddGuestModalView from "../../app/angularjs/events/guests/addGuestModal.html";

import _, { assign } from "lodash";

angular.module("app")

.service('eventService', ['$http','$q', 'Restangular', '$injector', '$state', 'modalService', '$filter', function ($http, $q, Restangular, $injector, $state, modalService, $filter) {
    let resultado = null;
    let $uibModal = $injector.get("$uibModal");
    let service = {
        getGuests: function (event_id) {
            var deferred = $q.defer();
            var promise = deferred.promise;
            var options = { event_id: event_id }
            $http({
                method: 'get',
                url: (window as any).CONFIG.api_url + '/EventsGuests/GetEventGuest',
                params: options
            }).then(function (data, status, headers, config) {                
                deferred.resolve(data);
            });
            return promise;
        },
        getStaff: function (event_id) {
            var deferred = $q.defer();
            var promise = deferred.promise;
            var options = { event_id: event_id }
            $http({
                method: 'get',
                url: (window as any).CONFIG.api_url + '/EventsStaff/GetEventStaff',
                params: options
            }).then(function (data, status, headers, config) {
                deferred.resolve(data);
            });
            return promise;
        },
        getTasks: function (event_id) {
            var deferred = $q.defer();
            var promise = deferred.promise;
            var options = { event_id: event_id }
            $http({
                method: 'get',
                url: (window as any).CONFIG.api_url + '/EventsTaks/GetEventTasks',
                params: options
            }).then(function (data, status, headers, config) {
                deferred.resolve(data);
            });
            return promise;
        },
        getMaterials: function (event_id) {
            var deferred = $q.defer();
            var promise = deferred.promise;
            var options = { event_id: event_id }
            $http({
                method: 'get',
                url: (window as any).CONFIG.api_url + '/EventsMaterials/GetEventMaterial',
                params: options
            }).then(function (data, status, headers, config) {
                deferred.resolve(data);
            });
            return promise;
        },
        getPendingInscriptions: function (event_id) {
            var deferred = $q.defer();
            var promise = deferred.promise;
            var options = { event_id: event_id }
            $http({
                method: 'get',
                url: (window as any).CONFIG.api_url + '/inscriptions/GetPendingInscriptions',
                params: options
            }).then(function (data, status, headers, config) {
                deferred.resolve(data);
            });
            return promise;
        },
        getSpaces: function (event_id) {
            return Restangular.one('events', + event_id).getList('spaces');
        },
        getSpaceZones: function (event_id, space_id) {
            return Restangular.one('events', + event_id).one('spaces', space_id).getList('zones');
        },
        addEventGuestSpaceZone: function (event_id, event_space_id, event_space_zone_id, event_guest_id) {
            return Restangular.one('events', event_id)
                .one('spaces', event_space_id)
                .one('zones', event_space_zone_id)
                .one('guests', event_guest_id).post();
        },
        modifyEventGuestSpaceZone: function (event_id, event_space_id, event_space_zone_id, event_guest_id) {
            return Restangular.one('events', event_id)
                .one('spaces', event_space_id)
                .one('zones', event_space_zone_id)
                .one('guests', event_guest_id).put();
        },
        configGuestModal: function (item, event, callback) {
            let instance = $uibModal.open({
                animation: true,
                template: ConfigGuestModalView,
                controller: 'ConfigGuestsModalCtrl',
                size: "lg-extra",
                resolve: {
                    item: function () {
                        return item;
                    },
                    event: function () {
                        return event;
                    }
                }
            });
            instance.result.then(function (result) {
                if (typeof callback === 'function') {
                    callback(result);
                }
            }, function () {
            })
        },
        searchMassiveGuestModal: function (event_id, callback) {
            let $modalInstance = $uibModal.open({
                animation: true,
                template: SearchGuestsModalView,
                size: "lg",
                controller: "SearchGuestsModalCtrl",
//                    scope: $scope,
                resolve: {
                    options: function () {
                        return {
                            onGuestsAdded: callback
                        };
                    }
                }
            });

            //Response del modal
            $modalInstance.result.then(function (data) {
                callback();
            }, function () {
                console.info('Modal dismissed at: ' + new Date());
            });


        },
        searchGroups: function (event_id, callback) {
            let $modalInstance = $uibModal.open({
                animation: true,
                template: SearchGroupModalView,
                size: "lg",
                controller: "SearchGroupModalCtrl",
                resolve: {
                    preselect: function () {
                        return true;  //para preseleccionar los grupos ya buscados
                    },
                    event_id: function () {
                        return event_id;
                    },
                    is_filter: function () {
                        return false;
                    },
                    listGroupsIds: function () {
                        return [];
                    },
                    listPositionsIds: function () {
                        return [];
                    }
                }
            });

            //Response del modal
            $modalInstance.result.then(function (groups) {
                var postGroups = { event_id: event_id, list: null, listPositions: groups.listPositions };

                if (typeof (groups) != 'undefined' && groups != null && groups.listPositions.length > 0) {

                    //Peticion al api para que me devuelva las personas que estan en esos grupos.
                    Restangular.all('EventsGuests/AddGuestFromGroups').post(postGroups).then(function (success) {
                        callback();
                    });
                }
            }, function () {
                console.info('Modal dismissed at: ' + new Date());
            });
        },

        addGuestDialog: function (event_id, callback) {

            let $modalInstance = $uibModal.open({
                animation: true,
                template: AddGuestModalView,
                size: "lg",
                controller: "AddGuestModalCtrl",
                resolve: {
                    params: function () {
                        return {
                            event_id: event_id,
                            referrer_person_id: null,
                            is_delegate: false
                        }
                    } 
                }
            });

            $modalInstance.result.then(function () {
                callback();
            }, function () {
                console.info('Modal dismissed at: ' + new Date());
            });

        },

        goToState: function (state, params) {
            $state.go(state, params);
        },
        assignParking: function(event, guestsIds, callback) {
            let $modalInstance = $uibModal.open({
                animation: true,
                template: AssignParkingsModalView,
                size: "lg",
                controller: "assignParkingMassiveModalCtrl",
                resolve: {
                    options: {},
                    event: function () {
                        return event;
                    }
                }
            });

            // Response del modal
            $modalInstance.result.then(function (options) {
                Restangular.all("EventsGuests").customPOST(guestsIds, "SetMassiveParkings", { value: options.parking_id, allow_parking: options.allow_parking, max_vehicles: options.max_vehicles, custom_parking_config: options.custom_parking_config }).then(function (results) {
                    // Pass the chosen parking options to the callback so the caller
                    // can update local guest data without a full server reload.
                    callback(options);
                })
            });
        },
        assignActs: function(event, guestsIds, callback) {
            let $modalInstance = $uibModal.open({
                animation: true,
                template: AssignActsModalView,
                size: "lg",
                controller: "assignActsMassiveModalCtrl",
                resolve: {
                    event_id: function () {
                        return event.id;
                    },
                }
            });

            // Response del modal
            $modalInstance.result.then(function (eventsProgramsActSelected) {
                //Seleccionamos los actos a los que invitado esta invitado.
                let event_acts_ids = [];
                angular.forEach(eventsProgramsActSelected, function (item, idx) {
                    if (item) event_acts_ids.push(idx);
                });

                if (event_acts_ids.length > 0) {
                    var epag = {
                        event_acts_ids: event_acts_ids,
                        guests_id: guestsIds,
                        event_id: event.id
                    }
                    //Guardamos los actos
                    $http({
                        method: 'post',
                        url: (window as any).CONFIG.api_url + 'EventsGuests/SetMassiveActsGuest',
                        data: epag,
                    }).then(function (resultsImage, status, headers, config) {
                        callback();
                    });
                }
            });            
        },
        assignZone: function(event, guestsIds, callback) {
            let $modalInstance = $uibModal.open({
                animation: true,
                template: AssignZoneModalView,
                size: "lg",
                controller: "assignZoneMassiveModalCtrl",
                resolve: {
                    options: {
                        only_one: false
                    }
                }
            });
            //Response del modal
            $modalInstance.result.then(function (option) {
                var params = {
                    event_guests_ids: guestsIds,
                    zone: option.zone,
                    companions_zone: option.companions_zone
                };

                $http({
                    method: 'post',
                    url: (window as any).CONFIG.api_url + 'EventsGuests/SetMassiveZones',
                    params: params
                }).then(function (results, status, headers, config) {
                    // Pass the chosen zone option to the callback so the caller
                    // can update local guest data without a full server reload.
                    callback(option);
                });
            });
        },
        setCompanionLimit: function(event, guestsIds, callback) {
            let $modalInstance = $uibModal.open({
                animation: true,
                template: AssignCompanionsLimitModalView,
                size: "md",
                controller: "assignCompanionsLimitModalCtrl",
                resolve: {
                    event: function () {
                        return event;
                    },
                    options: {}
                }
            });

            // Response del modal
            $modalInstance.result.then(function (option) {

                var params = { event_guests_ids: guestsIds, value: option.max_companions_allowed, is_companion_allowed: option.is_companions_allowed };

                $http({
                    method: 'post',
                    url: (window as any).CONFIG.api_url + 'EventsGuests/SetMassiveCompanions',
                    params: params
                }).then(function (results, status, headers, config) {
                    callback();
                });

            });
        },
        massiveRemove: function(event, guests, callback) {

            let is_invited = _.some(guests, function (guest) {
                return guest.send_status != 'unsent';
            });
            let guest_ids = _.map(guests, function (guest) {
                return guest.id;
            });

            let resolvedEventId = (event && event.id) || (guests.length > 0 ? guests[0] && guests[0].event_id : null);
            let deleteItems = {event_id: resolvedEventId, list: guest_ids}

            let delete_message = "";
            
            if (is_invited) delete_message = $filter('translate')('events.guests.invitation_already_sent_massive') + "<br>";
            delete_message += $filter('translate')('events.guests.delete_confirm_massive');
            modalService.confirm({
                title: $filter('translate')('events.guests.warning'),
                message: delete_message,
                onAccept: function () {
                    Restangular.all('EventsGuests/DeleteMassive').post(deleteItems).then(function (results, status, headers, config) {
                        callback();
                    });
                }
            });            
        },
        assignAccreditation: function(event, guestsIds, callback) {
            let $modalInstance = $uibModal.open({
                animation: true,
                template: AssignAccreditationModalView,
                // size: "lg",
                controller: "assignAccreditationMassiveModalCtrl",
                resolve: {
                    options: function () {
                        return {
                            event_id: event.id
                        }
                    }
                }
            });
            //Response del modal
            $modalInstance.result.then(function (option) {

                var params = {event_guests_ids: guestsIds, value: option.event_guest_accreditation_id};
                $http({
                    method: 'post',
                    url: (window as any).CONFIG.api_url + 'EventsGuests/SetMassiveAccreditions',
                    params: params
                }).then(function (results, status, headers, config) {
                    // Pass the chosen accreditation option to the callback so the caller
                    // can update local guest data without a full server reload.
                    callback(option);
                });
            });
        },
        assignAnnexes: function(event, guestsIds, callback) {
            let $modalInstance = $uibModal.open({
                animation: true,
                template: AssignAnnexesModalView,
                size: "lg",
                controller: "assignAnnexesModalCtrl",
                resolve: {
                    event_id: function () {
                        return event.id;
                    },
                }
            });
            //Response del modal
            $modalInstance.result.then(function (eventsAnnexesSelected) {
                //Seleccionamos los actos a los que invitado esta invitado.
                let events_annexes_ids = [];
                angular.forEach(eventsAnnexesSelected, function (item, idx) {
                    if (item) events_annexes_ids.push(idx);
                });

                if (events_annexes_ids.length > 0) {
                    var annexes = {
                        guests_ids: guestsIds,
                        event_id: event.id,
                        events_annexes_ids: events_annexes_ids
                    }

                    //Guardamos los actos
                    $http({
                        method: 'post',
                        url: (window as any).CONFIG.api_url + 'EventsGuests/SetAnnexesGuest',
                        data: annexes,
                    }).then(function (resultsImage, status, headers, config) {
                        callback();
                    });
                }
            });
        },
        assignSpaces: async function(event, guestsIds, callback) {
            let spaces = await this.getSpaces(event.id);
            spaces.push({ id: -1, name: $filter('translate')('events.guests.no_space') });

            /*
                spaces.forEach(function (space) {
                    space.FK_events_spaces_zones_events_spaces.push({ id: -1, name: $filter('translate')('events.guests.no_zone') })
                });
            */ 

            let $modalInstance = $uibModal.open({
                animation: true,
                template: GuestSpaceZonesModalView,
                controller: "GuestSpaceZonesModalCtrl",
                size: 'md',
                resolve: {
                    event_guest_zone: function () {
                        return undefined;
                    },
                    event_guest_id: function () {
                        return null;
                    },
                    spaces: function () {
                        return spaces;
                    }
                }
            });

            // Retorno de los datos desde el modal.
            $modalInstance.result.then(function (resultModal) {

                let spaceID = resultModal.spaceSelected.id;
                let zoneID = spaceID > 1 ? resultModal.event_guest_zone.id : null;

                // if (spaceID = -1) zoneID = -1; // Para desasingar

                Restangular.all('EventsGuests/MassiveChangeSpaceZone/' + spaceID + '/' + zoneID).post(guestsIds).then(function (response) {
                    callback();
                }, function (error) {
                });
            });
        },
        confirmSelected: function (event, guests, callback) {
            let selectedToConfirm = guests.filter(f => f.confirmation_status != "confirmed").map(m => m.id);
            let selectedToCheck = guests;

            let date = new Date();
            let day = date.getDate();
            let month = date.getMonth() + 1;
            let year = date.getFullYear();

            modalService.confirm({
                title: $filter('translate')('events.guests.confirm_selected'),
                message: $filter('translate')('events.guests.confirm_selected_message'),
                onAccept: function () {

                    Restangular.all('events/' + event.id + '/guests/confirmed').post(selectedToConfirm).then(function (result) {
                        callback();
                    });

                    // Asignamos a los actos en cuestion 
                    Restangular.all("EventsProgramsActs").customGET("GetEventConfirmableActs", { event_id: event.id }).then(function (res) {

                        if (res.length > 0) {
                            let epag = {
                                event_acts_ids: res.map(m => m.id),
                                guests_id: selectedToCheck.map(e => e.id),
                                event_id: event.id,
                                guest_id: null,
                                event_acts_show_ids: null
                            }
                            Restangular.all("EventsGuests").customPOST(epag, "SetMassiveActsGuest", {onlyConfirmableActs: true}).then(function (results) {
                                selectedToCheck.forEach(m => m.partial_attendance = false)
                            });
                        };
                    });
                }
            });
        },
    };

    return service;
}])

 .filter('to_trusted', ['$sce', function ($sce) {
     return function (text) {
         return $sce.trustAsHtml(text);
     };
 }]);
